/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentReportOntologyMigration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentReportOntologyMigration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentReportOntologyMigration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentReportOntologyMigration>): BackgroundJobPayloadForAssessmentReportOntologyMigration {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentReportOntologyMigration(), model);
        BackgroundJobPayloadForAssessmentReportOntologyMigration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentReportOntologyMigration>): BackgroundJobPayloadForAssessmentReportOntologyMigration {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentReportOntologyMigration.newInstance(<BackgroundJobPayloadForAssessmentReportOntologyMigration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentReportOntologyMigration) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentReportOntologyMigration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentReportOntologyMigration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentReportOntologyMigration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
